import { getField, updateField } from "vuex-map-fields";
import mutations from "./mutations"
import * as actions from "./actions"
export default {
    namespaced: true,
    state: {
        isLoading: false,
        item:null,
        showMessage: false,
        message: "",
        isSuccess: false,
        current_ticket:null,
        filter:{
            ticket_id:null
        }

    },
    actions,
    getters: {
        getField,

    },
    mutations: {
        updateField,
        ...mutations,
    },
}


// {
//     field: 'actions', title: 'Actions', hide: false, cellRenderer: () => {
//         return ` `
//     }
// },